module.exports = __webpack_public_path__ + "static/media/PALOSANTO_00.642ce20a.png";